// import React, { useEffect } from "react";
// import ObjectivesSection from "../ObjectivesSection";
// import GhatikLogo2 from "../../Images/GhatikLogo2.png";
// import dignitary1 from "../../Images/dignitary1.png";
// import dignitary2 from "../../Images/dignitary2.png";
// import dignitary3 from "../../Images/dignitary3.png";
// import dignitary4 from "../../Images/dignitary4.png";
// import dignitary5 from "../../Images/dignitary5.png";
// import dignitary6 from "../../Images/dignitary6.png";



// const Home = () => {
//   // Log user details from sessionStorage when the component mounts
//   const dignitaries = [
//     { photo: dignitary1, name: "Shri ABC", role: "President" },
//     { photo: dignitary2, name: "Shri XYZ", role: "Vice President" },
//     { photo: dignitary3, name: "Shri LMN", role: "Secretary" },
//     { photo: dignitary4, name: "Shri LMN", role: "Secretary" },
//     { photo: dignitary5, name: "Shri LMN", role: "Secretary" },
//     { photo: dignitary6, name: "Shri LMN", role: "Secretary" },
//   ];
  
//   useEffect(() => { 
//     const userDetails = {
//       username: sessionStorage.getItem("username"),
//       fullName: sessionStorage.getItem("fullName"),
//       userGroup: sessionStorage.getItem("userGroup"),
//       id: sessionStorage.getItem("id"),
//       primaryRequirement: sessionStorage.getItem("primaryRequirement"),
//       district: sessionStorage.getItem("district"),
//       token: sessionStorage.getItem("token"),
//     };

//     console.log("User Details from sessionStorage:", userDetails);
//   }, []); // Empty dependency array ensures this runs only once on mount

//   return (
//     <div className="home-page">
//       {/* Hero Section */}
//       <section className="hero-section">

//         <h2 className="hero-heading">
//           Empowering the Hindu Khatik Samaj Through Financial Support
//         </h2>

//         <div className="hero-content">
//           {/* Left: Image */}
//           <div className="hero-image">
//             <div className="image-placeholder">[ Image Placeholder ]</div>
//           </div>

//           {/* Right: Text */}
//           <div className="hero-text">
//             <p>
//               This website is dedicated to the development and upliftment of the Hindu Khatik Samaj.
//               Through special financial schemes, we aim to support self-employment, entrepreneurship,
//               and economic independence. These schemes are implemented with the help of the Mahatma Phule
//               Backward Classes Development Corporation, ensuring easy access to financial assistance
//               for eligible individuals from the Khatik community.
//             </p>
//           </div>
//         </div>

//         </section>




//       {/* Important Notice */}
//       <div className="important-notice">
//         <span className="highlight">IMPORTANT NOTICE :</span> [EOI for selection of Advisory Consultant to Study of Renewable initiatives and provides advisory services.]
//       </div>

//       {/* Our Schemes */}
//       <section className="schemes-section">
//         <h3>OUR SCHEMES</h3>
//         <div className="scheme-cards">
//           <div className="scheme-card">
//             <h4>Money Margin</h4>
//             <p>
//               This scheme supports self-employment for projects with an investment of up to ₹5 Lakhs.
//             </p>
//             <div className="card-actions">
//               <button className="read-more">Read More</button>
//               <button className="apply-btn">APPLY</button>
//             </div>
//           </div>

//           <div className="scheme-card">
//             <h4>Direct Finance</h4>
//             <p>
//               Designed for quicker access to finance without bank involvement, this scheme offers loans up to ₹1 Lakh directly from the Corporation.
//             </p>
//             <div className="card-actions">
//               <button className="read-more">Read More</button>
//               <button className="apply-btn">APPLY</button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Key Dignitaries */}
//       <section className="dignitaries-section">
//         <h3>KEY DIGNITARIES</h3>
//         <div className="dignitaries-grid">
//           {dignitaries.map((d, index) => (
//             <div className="dignitary-card" key={index}>
//               <img src={d.photo} alt={d.name} className="dignitary-photo" />
//               <div className="dignitary-info">
//                 <p className="dignitary-name">{d.name}</p>
//                 <p className="dignitary-role">{d.role}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* About Us */}
//       <section className="about-section">
//         <div className="about-logo">
//         <img src={GhatikLogo2} alt="GhatikLogo" className="Ghatik-Logo" />
//         </div>
//         <div className="about-text">
//           <div className='about-title'><h3>ABOUT US</h3></div>
//           <div className='about-contetnt'>
//           <p>
//           HINDU KHATIK SAMAJ ECONOMIC DEVELOPMENT CORPORATION is a dedicated initiative working toward the upliftment and empowerment of the Hindu Khatik community. We aim to provide structured welfare programs, improve access to resources, and enable self-sustaining livelihoods.
//           Through strategic support such as grants, skill development, and collaborations, we work to build a more inclusive, educated, and economically resilient future for the community.
//           </p>
//           <button className="apply-btn">Read More</button>
//           </div>
          
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Home;

import React from 'react';
import GhatikLogo2 from "../../Images/GhatikLogo2.png";
import dignitary1 from "../../Images/dignitary1.png";
import dignitary2 from "../../Images/dignitary2.png";
import dignitary3 from "../../Images/dignitary3.png";
import dignitary4 from "../../Images/dignitary4.png";
import dignitary5 from "../../Images/dignitary5.png";
import dignitary6 from "../../Images/dignitary6.png";
import HKS from "../../Images/HKS.svg";
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  const handleDirectFinanceClick = () => {
    navigate('/direct-finance-scheme'); // Your route path
  };
  const handleMarginMoneyClick = () => {
    navigate('/margin-money-scheme'); // Your route path
  };
  const handleAboutClick = () => {
    navigate('/about'); // Your route path
  };
  const dignitaries = [
    { image: dignitary1 , name: 'Shri.Devendra Fadnavis', role: "Hon. Chief Minister, Maharashtra State" },
    { image: dignitary2 ,name: 'Shri. Eknath Shinde', role: "Hon. Deputy Chief Minister, Maharashtra State" },
    { image: dignitary3 ,name: 'Smt. Sunetra Ajit Pawar', role: "Hon. Deputy Chief Minister, Maharashtra State" },
    { image: dignitary4 ,name: 'Shri. Sanjay Shirsat', role: "Hon'ble Minister, Social Justice" },
    { image: dignitary5 ,name: 'Smt. Madhuri Misal', role: "Hon'ble State Minister, Social Justice" },
    { image: dignitary6 ,name: 'Shri. Ruchesh Jaivanshi (IAS)', role: "Hon'ble Managing Director" },
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section py-12 px-8 bg-gray-50">
        <h2 className="text-3xl  text-center text-blue-900 mb-8" style={{ color: "#193367", textDecoration: "underline" }}>
          Empowering the Hindu Khatik Samaj Through Financial Support
        </h2>
        <div className="flex flex-col md:flex-row items-center  px-20 gap-8">
          <div className="md:w-2/5">
            <div className="bg-white-200 h-64  flex items-center justify-center text-gray-500">
            
            <img src={HKS} alt="HKS" style={{width:"100%",height:"100%"}}/>
            </div>
          </div>
          <div className="md:w-1/2">
            <p className="text-black-700  font-bold text-left leading-relaxed" style={{marginLeft:"40px", fontSize:"16px"}}>
              This website is dedicated to the development and upliftment of the Hindu Khatik Samaj. Through special financial schemes, we aim to support self-employment, entrepreneurship, and economic independence. These schemes are implemented with the help of the Mahatma Phule Backward Classes Development Corporation, ensuring easy access to financial assistance for eligible individuals from the Khatik community.
            </p>
          </div>
        </div>
      </section>

      <div className="important-notice py-4 px-8 bg-white text-center relative overflow-hidden">
  {/* Static Important Notice */}
  <div className="text-red-600 font-bold mb-2" style={{ color: "#193367", textDecoration: "underline" }}>
    IMPORTANT NOTICE :
  </div>

  {/* Moving Text with NEW sticker */}
  <div className="whitespace-nowrap overflow-hidden relative">
    <div
      className="inline-flex items-center animate-marquee"
      style={{ animation: "marquee 12s linear infinite" }}
    >
      {/* Glowing RGB background */}
      <div className="relative flex items-center justify-center">
        <div className="absolute inset-0 rounded-full blur-2xl opacity-70 animate-glow" />

        {/* New Sticker with spiked star */}
        <svg viewBox="0 0 512 512" width="120" height="40">
          <path
            fill="#FF0000"
            d="M256 0l40 120 100-80-20 120 120-20-80 100 120 40-120 40 80 100-120-20 20 120-100-80-40 120-40-120-100 80 20-120-120 20 80-100-120-40 120-40-80-100 120 20-20-120 100 80 40-120z"
          />
          <text
            x="50%"
            y="55%"
            textAnchor="middle"
            fill="white"
            fontSize="130"
            fontWeight="bold"
            fontFamily="Arial"
            dy=".3em"
          >
            NEW
          </text>
        </svg>
      </div>

      {/* Small padding between NEW and EOI text */}
      <span className="ml-0 text-gray-700 text-lg font-medium">
        EOI for selection of Advisory Consultant to Study of Renewable initiatives and provides advisory services.
      </span>
    </div>
  </div>
    </div>

    {/* Animation and Glow CSS */}
    <style>
      {`
        @keyframes marquee {
          0%   { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }

        @keyframes glow {
          0% {
            background: radial-gradient( red 0%, transparent 30%);
          }
          33% {
            background: radial-gradient( yellow 0%, transparent 30%);
          }
          66% {
            background: radial-gradient( blue 0%, transparent 30%);
          }
          100% {
            background: radial-gradient( red 0%, transparent 30%);
          }
        }

        .animate-glow {
          animation: glow 1s ease-in-out infinite;
        }
      `}
    </style>








      {/* Our Schemes */}
      <section className="schemes-section py-12 px-8 bg-gray-50">
        <h3 className="text-2xl  text-center text-blue-900 mb-8"style={{ color: "#193367", textDecoration: "underline" }}>OUR SCHEMES</h3>
        <div className="flex flex-col md:flex-row justify-center gap-20">
        <div className="scheme-card p-6 rounded-lg w-full md:w-1/3" style={{ backgroundColor: "#EBEDF0", height: "350px", width: "300px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
  
          {/* Heading with custom underline */}
          <div className="text-center mb-4">
            <div className="inline-block relative">
              <h4 className="text-xl font-semibold text-blue-900" style={{ color: "#193367" }}>
                Money Margin
              </h4>
              <div 
                className="absolute left-1/2 transform -translate-x-1/2"
                style={{
                  marginTop: "-7px",
                  width: "80%",
                  height: "1px",
                  backgroundColor: "#193367"
                }}
              />
            </div>
          </div>

          {/* Description */}
          <p className="text-gray-700 mb-4" style={{ textAlign: "left", fontWeight: "bold" ,fontSize:"16px" }}>
            This scheme supports self-employment for projects with an investment of up to ₹5 Lakhs.
          </p>

          {/* Buttons aligned to corners */}
          <div className="flex justify-between mt-auto">
            <button  onClick={handleMarginMoneyClick}className="text-blue-600 hover:underline"style={{textDecoration:"underline", color:"#304776", fontWeight:"bold"}}>Read More</button>
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"style={{ background:"#304776",width:"130px" }}>APPLY</button>
          </div>

        </div>

        <div className="scheme-card p-6 rounded-lg w-full md:w-1/3" style={{ backgroundColor: "#EBEDF0", height: "350px", width: "300px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
          
          {/* Heading with custom underline */}
          <div className="text-center mb-4">
            <div className="inline-block relative">
              <h4 className="text-xl font-semibold text-blue-900" style={{ color: "#193367" }}>
              Direct Finance
              </h4>
              <div 
                className="absolute left-1/2 transform -translate-x-1/2"
                style={{
                  marginTop: "-7px",
                  width: "80%",
                  height: "1px",
                  backgroundColor: "#193367"
                }}
              />
            </div>
          </div>

          {/* Description */}
          <p className="text-gray-700 mb-4" style={{ textAlign: "left", fontWeight: "bold" ,fontSize:"16px"}}>
          Designed for quicker access to finance without bank involvement, this scheme offers loans up to ₹1 Lakh directly from the Corporation.
          </p>

          { /* Buttons aligned to corners */}
          <div className="flex justify-between mt-auto">
              <button   onClick={handleDirectFinanceClick}  className="text-blue-600 hover:underline"style={{textDecoration:"underline", color:"#304776", fontWeight:"bold"}} >Read More</button>
              <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"style={{ background:"#304776",width:"130px" }}>APPLY</button>
          </div>

        </div>

        </div>
      </section>

      {/* Key Dignitaries */}
  
  
  <section className="dignitaries-section py-10 px-2 bg-white">
  <h3 className="text-2xl text-center mb-12" style={{ textDecoration: "underline", color: "#304776" }}>
    KEY DIGNITARIES
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6" >
    {dignitaries.map((d, index) => (
      <div 
        key={index} 
        className="overflow-hidden rounded-lg border border-gray-300 shadow-md bg-white"
        style={{width:"190px", height:"300px"}}
      >
        {/* IMAGE PART */}
        <div className="w-full">
          <img 
            src={d.image} 
            alt={d.name} 
            className="rounded-t-lg object-cover w-full h-50"
            style={{ objectPosition: "center" }}
          />
        </div>

        {/* BLUE BACKGROUND PART */}
        <div 
          className="pt-1 pb-2 px-2 text-white text-center"
          style={{ backgroundColor: "#1F3A68" ,height:"100%"}}
        >
          {/* WHITE LINE */}
          <div 
            className="mx-auto mb-0" 
            style={{ width: "55%", height: "2px", backgroundColor: "white" }}
          />
          
          {/* NAME */}
          <p className="font-semibold text-lg" style={{fontSize:"16px"}}>{d.name}</p>
          
          {/* ROLE */}
          <p className="text-sm whitesace-pre-line" style={{fontSize:"10px", fontWeight:"semi-bold"}}>{d.role}</p>
        </div>
      </div>
    ))}
  </div>
</section>





      {/* About Us */}
      <section className="about-section py-12 px-8 bg-gray-50 flex flex-col md:flex-row items-center gap-8">
        <div className="md:w-1/3">
          <img
            src={GhatikLogo2}
            alt="Ghatik Logo"
            className="h-80 mx-auto"
          />
        </div>
        <div className="md:w-2/3" style={{textAlign:"left",marginLeft:"60px" ,marginRight:"40px",marginTop:"140px"}}>
          <h3 className="text-2xl  text-blue-900 mb-"style={{ marginTop:"-250px",paddingBottom:"50px",textAlign:"left" ,textDecoration:"underline"}}>ABOUT US</h3>
          <p className="text-gray-700 mb-4" style={{textAlign:"left",color:"#000000",fontWeight:"bold"}}>
          HINDU KHATIK SAMAJ ECONOMIC DEVELOPMENT CORPORATION is a dedicated initiative working toward the upliftment and empowerment of the Hindu Khatik community. We aim to provide structured welfare programs, improve access to resources, and enable self-sustaining livelihoods.
          Through strategic support such as grants, skill development, and collaborations, we work to build a more inclusive, educated, and economically resilient future for the community. </p>
          <button  onClick={handleAboutClick} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" style={{background:"#314877"}}>Read More</button>
        </div>
      </section>
    </div>
  );
};

export default Home;